import { render } from "./BlogDetailsLeftSidebar.vue?vue&type=template&id=42cc89c2&ts=true"
import script from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=ts"
export * from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__